export const MINESWEEPER_WIDTH = 12;
export const MINESWEEPER_HEIGHT = 12;
export const MINESWEEPER_CELL_COUNT = MINESWEEPER_WIDTH * MINESWEEPER_HEIGHT;
export const MINESWEEPER_MINE_COUNT = 20;

export type MinesweeperPuzzle = {
  width: 12;
  height: 12;
  mineCount: 20;
  mines: number[];
  values: number[];
  startIndex: number;
  openingSize: number;
  generationAttempts: number;
};

export function isMinesweeperPuzzle(value: unknown): value is MinesweeperPuzzle {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<MinesweeperPuzzle>;
  if (
    candidate.width !== MINESWEEPER_WIDTH ||
    candidate.height !== MINESWEEPER_HEIGHT ||
    candidate.mineCount !== MINESWEEPER_MINE_COUNT ||
    !Array.isArray(candidate.mines) ||
    candidate.mines.length !== MINESWEEPER_MINE_COUNT ||
    new Set(candidate.mines).size !== MINESWEEPER_MINE_COUNT ||
    !candidate.mines.every(
      (index) => Number.isInteger(index) && index >= 0 && index < MINESWEEPER_CELL_COUNT,
    ) ||
    !Array.isArray(candidate.values) ||
    candidate.values.length !== MINESWEEPER_CELL_COUNT ||
    !candidate.values.every((cell) => Number.isInteger(cell) && cell >= -1 && cell <= 8) ||
    !Number.isInteger(candidate.startIndex) ||
    candidate.startIndex! < 0 ||
    candidate.startIndex! >= MINESWEEPER_CELL_COUNT ||
    !Number.isInteger(candidate.openingSize) ||
    candidate.openingSize! < 12 ||
    !Number.isInteger(candidate.generationAttempts) ||
    candidate.generationAttempts! < 1 ||
    candidate.generationAttempts! > 5_000
  ) {
    return false;
  }
  const mines = new Set(candidate.mines);
  const startIndex = candidate.startIndex as number;
  return (
    candidate.values[startIndex] === 0 &&
    candidate.mines.every((index) => candidate.values![index] === -1) &&
    candidate.values.every((value, index) => (mines.has(index) ? value === -1 : value >= 0))
  );
}
